module.exports = __webpack_public_path__ + "static/media/themplane2.867b2411.webp";